import { render, staticRenderFns } from "./DownloadPageContainer.vue?vue&type=template&id=3a5c882a&scoped=true&"
import script from "./DownloadPageContainer.vue?vue&type=script&lang=js&"
export * from "./DownloadPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c882a",
  null
  
)

export default component.exports